{
  "ChartstyleoptionsPie2d": "Torta (2D)",
  "ChartstyleoptionsPie3d": "Torta (3D)",
  "ChartstyleoptionsDoughnut2d": "Rosquinha (2D)",
  "ChartstyleoptionsDoughnut3d": "Rosquinha (3D)",
  "ChartstyleoptionsLine": "Linha",
  "ChartstyleoptionsArea": "Área",
  "ChartstyleoptionsAreastacked": "Área (empilhada)",
  "ChartstyleoptionsRadarpolararea": "Radar (Área Polar)",
  "ChartstyleoptionsColumn2d": "Coluna (2D)",
  "ChartstyleoptionsColumn2dstacked": "Coluna (2D, Empilhado)",
  "ChartstyleoptionsColumn3d": "Coluna (3D)",
  "ChartstyleoptionsColumn3dstacked": "Coluna (3D, Empilhado)",
  "ChartstyleoptionsBar2d": "Barra (2D)",
  "ChartstyleoptionsBar2dstacked": "Barra (2D, empilhada)",
  "ChartstyleoptionsBar3d": "Barra (3D)",
  "ChartstyleoptionsBar3dstacked": "Barra (3D, empilhada)",
  "NAME": "ChartStyleOptions"
}